export const getWatermark = (locale?: string, url?: string) => {
  if (!url) {
    return ''
  }
  const defaultImageRegExp = new RegExp(`(${locale?.slice(-2)}\.png)$`, 'g')
  if (defaultImageRegExp.test(url)) {
    return url
  }
  return `${url}?wm=1`
}
